<template>
    <div>
        <div class="navigation">
            <div class="nav-btn menu" @click="isShow()" :class="showMenu?'menu-white':''">
                <div class="text-mask">
                    <p>{{activePage + 1}}/{{componentsNum + 1}}</p>
                    <i class="iconfont">{{showMenu?'&#xe67c;':'&#xe67e;'}}</i>
                </div>
                <span class="moveSpan">{{showMenu?'关闭':'目录'}}</span>
            </div>
            <div class="nav-btn sing-in" @click="baoMing(7)" v-if=" activePage != 7">
                <div class="bgc"></div>
                报名<br>
                参选
            </div>
        </div>
        <div class="menu-body" :class="{'showMenu':showMenu,'rank': rank}">
            <div class="menu-content">
                <div class="nav">
                    <p v-for="(item,index) in menu" :key="index">
                        <span :class="activePage == item.pageId? 'active-index':''" @click="navPage(item.pageId)">{{item.name}}</span>
                    </p>
                </div>
                <div class="msg">
                    <div class="history">
                        <p>往届回顾</p>
                        <a href="https://vcbeat.top/VB100/vb100List" target="_blank">2016未来医疗100强榜单</a>
                        <a href="https://vcbeat.top/VB100/vb100List" target="_blank">2017未来医疗100强榜单</a>
                        <a href="https://vcbeat.top/VB100/vb100List" target="_blank">2018未来医疗100强榜单</a>
                        <a href="https://vcbeat.top/VB100/vb100List" target="_blank">2019未来医疗100强榜单</a>
                    </div>
                    <div class="contact">
                        <div class="people">
                            <p class="contract-p1">曾女士</p>
                            <img class="logo1" :src="static_img_url + 'pic/index/zeng.png'">
                            <p class="contract-p2">13883394550</p>
                            <p class="contract-p2">Zeng.xs@vcbeat.net</p>
                        </div>
                        <div class="people">
                            <p class="contract-p1">李女士</p>
                            <img class="logo1" :src="static_img_url + 'pic/index/li.png'">
                            <p class="contract-p2">18428384021</p>
                            <p class="contract-p2">Li.jl@vcbeat.net</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="menu-mask" @click="isShow()"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        activePage: Number,
        nextPage: Number,
        componentsNum: Number,
        jumpView: Number
    },
    data(){
        return {
            static_img_url: process.env.VUE_APP_CDN,

            showMenu: false,
            rank: false,
            menu:[
                { pageId: 0, name: '未来医疗100强' },
                { pageId: 2, name: '主榜' },
                { pageId: 3, name: '大企业榜' },
                { pageId: 4, name: '创新产业集群榜' },
                { pageId: 5, name: '价值领域榜' },
                { pageId: 6, name: '澎橙奖' },
            ]
        }
    },
    methods:{
        isShow(){
            if( !this.showMenu && !this.rank){
                this.showMenu = true
                this.rank = true
                return 
            }
            if(this.showMenu && this.rank){
                this.showMenu = false
                setTimeout(() =>{
                    this.rank = false
                },600)
            }
        },
        navPage(pageId){
            if( pageId == this.activePage){
                this.isShow()
                return
            }
            this.$emit('setJumpView',pageId)
            this.$emit('setLock',false)
            this.$emit('setNextPage',pageId)
            this.isShow()
        },
        baoMing(pageId){
            this.$emit('setJumpView',pageId)
            this.$emit('setLock',false)
            this.$emit('setNextPage',pageId)
        }
    }
};
</script>

<style lang="stylus" scoped>
@import '~styles/icons.css'
@import '~styles/common.stylus';
.navigation
    position fixed
    z-index 10
    .nav-btn
        position fixed
        cursor pointer
        right 80px
        display flex
        align-items center
        justify-content center
        width 60px
        height 60px
        border-radius 30px
        transition all .3s
        color #ffffff
        @media screen and (max-width: 1366px)
            width 50px
            height 50px
            font-size 13px
        &:nth-child(1)
            background #232323
            top px2vh(80)
            box-shadow:0px 0px 8px 2px rgba(0,0,0,0.3);
            .text-mask
                position absolute
                z-index 1
                right 0
                top 0
                background #232323
                width 60px
                height 60px
                border-radius 30px
                display flex
                align-items center
                justify-content center
                flex-direction column
                transition all .3s
                padding 16px
                @media screen and (max-width: 1366px)
                    width 50px
                    height 50px
                i
                    font-size 14px
                    margin-left auto
                    margin-top 5px
            span 
                position absolute
                left 20px
                transition all .3s
            &:nth-child(1):hover
                width 155px
                span 
                    left 40px
        &:nth-child(2)
            top px2vh(180)
            >div
                position absolute
                width 100%
                height 100%
                &:after
                    content: ''
                    position absolute
                    z-index -1
                    width 100%
                    height 100%
                    background:linear-gradient(-45deg,rgba(214,162,77,1),rgba(255,215,149,1))
                    border-radius 50%
                    transition all .3s
            &:hover
                &>div:after
                    transform scale(1.2)
    .menu-white
        background #ffffff !important
        color #000
        .text-mask
            background #ffffff !important
.menu-body
    position fixed
    top 0
    bottom 0
    left 0
    right 0
    background: rgba(0,0,0,0);
    transition all .6s
    .menu-mask
        position absolute
        left 0
        right 0
        top 0
        bottom 0
    .menu-content
        position absolute
        right 0
        top 0
        width px2vw(1200)
        min-width 1000px
        height 100%
        background #232323
        padding 80px
        transition all .6s
        transform translateX(100%)
        z-index 2
        @media screen and (max-width: 1366px)
            min-width 800px
            padding 50px
        .nav
            display flex
            flex-direction column
            p
                font-size 44px
                transition all .6s
                @media screen and (max-height: 750px)
                    font-size 30px
                span
                    cursor pointer
                    color #ffffff
                    &:hover
                        background:linear-gradient(-45deg,rgba(214,162,77,1) 0%, rgba(255,215,149,1) 100%);
                        -webkit-background-clip:text;
                        -webkit-text-fill-color:transparent;
                .active-index
                    background:linear-gradient(-45deg,rgba(214,162,77,1) 0%, rgba(255,215,149,1) 100%);
                    -webkit-background-clip:text;
                    -webkit-text-fill-color:transparent;
            p + p
                margin-top 20px
    &.showMenu
        background: rgba(0,0,0,.6);
        .menu-content
            transform translateX(0)
    &.rank
        z-index 5
    .msg
        position absolute
        bottom 30px
        width calc(100% - 160px)
        display flex
        flex-direction row
        background: #232323;
        padding 20px 0
        @media screen and (max-width: 1366px)
            width calc(100% - 100px)
        .history
            display flex
            flex-direction column
            color #fff
            >p
                position relative
                font-size:16px;
                height 25px
                &:after
                    content:''
                    width:26px;
                    height:1px;
                    background:linear-gradient(90deg,rgba(214,162,77,1),rgba(255,215,149,1));
                    position absolute
                    bottom 0
                    left 0
            a
                font-size:16px;
                color #fff
                margin-top 20px
                &:hover
                    background:linear-gradient(-45deg,rgba(214,162,77,1) 0%, rgba(255,215,149,1) 100%);
                    -webkit-background-clip:text;
                    -webkit-text-fill-color:transparent;
        .contact
            display flex
            flex-direction row
            position absolute
            right 0
            top px2vh(-20)
            transition all .6s
            @media screen and (max-width: 1366px)
                transform scale(.75) translateX(100px)
            .people
                position relative
                width:300px;
                height:228px;
                border:1px solid #D6A24D;
                padding 30px
                border-image: -webkit-linear-gradient(#D6A24D,#FFD795) 30 30;
                border-image: -moz-linear-gradient(#D6A24D,#FFD795) 30 30;
                border-image: linear-gradient(#D6A24D,#FFD795) 30 30;
                color:#FFFFFF
                .contract-p1
                    position: absolute
                    background:#232323
                    right:40px
                    height: 22px
                    padding 0 25px
                    text-align:center
                    top: -11px
                    font-size:24px;
                img 
                    width:100px;
                .contract-p2
                    font-size:18px;
                    font-weight:bold;
                    line-height:15px;
                    margin-top 20px
                &:nth-child(2)
                    margin-left 20px


</style>